import type {
  TDailyIrrigation,
  TEventWithDateRange,
  TPulseEventWithDateRanges,
} from 'App/irrigation-scheduler/utils/store/types'
import type { Moment } from 'moment-timezone'
import { calculateAppliedDepth } from './calculateAppliedDepth'
import { sumEventDurationsInWindow } from './sumEventDurationsInWindow'
import { sumPulseEventDurations } from './sumPulseEventDurations'

export const computeDailyIrrigation = (
  days: Moment[],
  events: TEventWithDateRange[],
  pulseEvents: TPulseEventWithDateRanges[],
  flowRateMmPerHour: number,
): TDailyIrrigation[] =>
  days.map((day) => {
    const dayStart = day.clone().startOf('day')
    const dayEnd = day.clone().endOf('day')
    const continuousDuration = sumEventDurationsInWindow(events, dayStart, dayEnd)
    const pulseDuration = sumPulseEventDurations(pulseEvents, dayStart, dayEnd)
    const duration = continuousDuration + pulseDuration
    const depthMm = calculateAppliedDepth(duration, flowRateMmPerHour)

    return { duration, depthMm }
  })
